module.exports = __webpack_public_path__ + "static/media/031.e093128b.jpg";